import AddMarketing from './AddMarketing';

export default (props) => {
  return <AddMarketing {...props} />;
};
